/**
 * FAQ — wrapper FaqSplit avec defaults du profil Particulier.
 *
 * Réutilise le bloc partagé FaqSplit (qui injecte FAQPage JSON-LD) mais avec :
 *  - contactLabel par défaut → CTA "écrivez-nous" pointant vers /contact?source=particulier
 *  - description par défaut adaptée au ton "warm-pedagogic"
 *
 * Le bloc reste accessible directement via FaqSplit pour les autres profils.
 */

import { FaqSplit } from '../../blocks/FaqSplit';
import { PARTICULIER_URLS } from '../../../config/audience/particulier.ui';

export interface ParticulierFaqItem {
  question: string;
  answer: string;
}

export interface ParticulierFAQProps {
  eyebrow?: string;
  title?: string;
  description?: string;
  items: ParticulierFaqItem[];
}

export function ParticulierFAQ({
  eyebrow = 'Vos questions',
  title = 'On vous répond simplement.',
  description = "Si une réponse manque, écrivez-nous. On vous répond sous 24 h ouvrées avec sources documentées.",
  items,
}: ParticulierFAQProps) {
  return (
    <FaqSplit
      eyebrow={eyebrow}
      title={title}
      description={description}
      contactLabel="Poser une question →"
      contactHref={PARTICULIER_URLS.contact}
      items={items}
    />
  );
}
